module.exports = __webpack_public_path__ + "static/media/light_bg-login.6255332e.svg";